import { useState } from "react"
import styled from "styled-components"

import SVGIcon from "components/presenters/common/SVGIcon"

export default function ToolTip() {
  const [visible, setVisible] = useState(true)

  if (!visible) return null
  return (
    <ToolTipBlock>
      <Text>제품 수령 후,인증시작!</Text>
      <CloseBtn onClick={() => setVisible(false)}>
        <SVGIcon name={"close"} />
      </CloseBtn>
      <Arrow />
    </ToolTipBlock>
  )
}

const ToolTipBlock = styled.div`
  position: absolute;
  top: calc(100vw * (37 / 375));
  left: calc(100vw * (-9 / 375));
  display: flex;
  align-items: center;
  justify-content: space-around;
  background-color: #fff;
  padding-top: calc(100vw * (11.38 / 375));
  padding-bottom: calc(100vw * (11.38 / 375));
  padding-left: calc(100vw * (15 / 375));
  padding-right: calc(100vw * (10 / 375));
  border-radius: calc(100vw * (5 / 375));
  box-shadow: 0px calc(100vw * (9 / 375)) calc(100vw * (28 / 375)) calc(100vw * (8 / 375))
      rgba(0, 0, 0, 0.05),
    0px calc(100vw * (6 / 375)) calc(100vw * (16 / 375)) rgba(0, 0, 0, 0.08),
    0px calc(100vw * (3 / 375)) calc(100vw * (6 / 375)) calc(100vw * (-4 / 375)) rgba(0, 0, 0, 0.12);
  width: calc(100vw * (158 / 375));
`

const Arrow = styled.div`
  position: absolute;
  top: calc(100vw * (-5 / 375));
  left: calc(100vw * (20 / 375));
  transform: rotate(45deg);
  width: calc(100vw * (10 / 375));
  height: calc(100vw * (10 / 375));
  background-color: #fff;
`

const Text = styled.span`
  font-size: calc(100vw * (12 / 375));
  font-weight: 500;
  line-height: calc(100vw * (17.38 / 375));
  color: #4e4e4e;
`

const CloseBtn = styled.div`
  width: calc(100vw * (10 / 375));
  height: calc(100vw * (10 / 375));
  svg {
    color: #7f7f7f;
  }
`
